import ReactDatePicker from "react-datepicker"
import styled from "styled-components"

import "react-datepicker/dist/react-datepicker.css"
import { theme } from "../../styles/theme"

export const DatePicker = styled(ReactDatePicker)`
    border: ${theme.borders.menu};
    border-radius: ${theme.radii.small};
    background-color: ${theme.colors.White};
    max-width: 100%;
    text-align: start;

    transition: all ${theme.transitions.normal} ease-out;
    
    padding: 1em 2em 1em 1em;
    background-image: linear-gradient(45deg,transparent 50%,gray 50%), linear-gradient(135deg,gray 50%,transparent 50%);
    background-position: calc(100% - 1em) calc(50%), calc(100% - 1em + 5px) calc(50%);
    background-size: 5px 5px, 5px 5px;
    background-repeat: no-repeat;
    background-origin: padding-box;

    :hover {
        background-color: ${theme.colors.MediumGrey};;
    }
`